// Column layout for sliders

/*  We have 2 (currently) slider layouts in this theme.
 *  on both sliders the cards have fixed widths and fixed margins per
 *  breakpoint.
 *
 *  There will be a peek on the right side of the screen below 1440px.
 *  .splide__track: overflow: visible.
 *
 *  The main slider has max 4 cards on desktop,
 *  This slider will appear to be contained at the edges of the grid at the
 *  smallest width of each breakpoint.
 *  When this slider is destroyed, this version uses flex grow and fixed
 *  margins to allow the cards to fill the space.
 *
 *  The second type of slider has max 5 cards on desktop.
 *  This is the education card slider.
 *  When this slider is destroyed, this version uses justify-content,
 *  max-width and fixed margins so it is left aligned.
 *
 */

export function getBreakpointOptions(module) {
  let breakpoints;
  let sliderType = module.dataset.sliderType;
  let spotlightVisVal =
    sliderType == 'spotlight' || sliderType == 'visual-value';
  let aspectRatio = module?.dataset?.aspectRatio;
  let sliderLayout = module.dataset.sliderLayout;
  let cardCount = parseInt(module.dataset.blockCount);
  switch (true) {
    case spotlightVisVal && cardCount == 2:
      breakpoints = {
        0: {
          fixedWidth: '241px',
          gap: '16px',
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
        },
        500: {
          fixedWidth: '348px',
          gap: '24px',
        },
        769: {
          fixedWidth: '451px',
          gap: '40px',
        },
        1025: {
          fixedWidth: '411px',
          gap: '40px',
          drag: false,
        },
      };
      break;
    case spotlightVisVal && cardCount == 3:
      breakpoints = {
        0: {
          fixedWidth: '241px',
          gap: '16px',
          arrows: false,
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
        },
        500: {
          fixedWidth: '254px',
          arrows: true,
          gap: '24px',
        },
        769: {
          fixedWidth: '329px',
          arrows: true,
          gap: '40px',
        },
        1025: {
          fixedWidth: '411px',
          arrows: false,
          gap: '40px',
        },
      };
      break;
    case spotlightVisVal && cardCount == 4:
      breakpoints = {
        0: {
          fixedWidth: '241px',
          gap: '16px',
          arrows: true,
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
        },
        500: {
          fixedWidth: '254px',
          arrows: true,
          gap: '24px',
        },
        769: {
          fixedWidth: '329px',
          arrows: true,
          gap: '40px',
        },
        1025: {
          fixedWidth: '298px',
          arrows: false,
          gap: '40px',
        },
      };
      break;
    case spotlightVisVal && cardCount > 4:
      breakpoints = {
        0: {
          fixedWidth: '241px',
          gap: '16px',
          arrows: true,
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
        },
        500: {
          fixedWidth: '254px',
          gap: '24px',
        },
        769: {
          fixedWidth: '329px',
          gap: '40px',
        },
        1025: {
          fixedWidth: '298px',
          gap: '40px',
        },
      };
      break;
    case sliderType == 'compare':
      breakpoints = {
        0: {
          fixedWidth: '241px',
          gap: '16px',
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
        },
        500: {
          fixedWidth: '254px',
          gap: '24px',
        },
        769: {
          fixedWidth: '329px',
          gap: '40px',
        },
        1025: {
          fixedWidth: '271px',
          gap: '24px',
        },
      };
      break;
    case sliderType == 'condensed-compare':
      breakpoints = {
        0: {
          fixedWidth: '156px',
          gap: '9px',
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
        },
        500: {
          fixedWidth: '209px',
          gap: '15px',
        },
        769: {
          fixedWidth: '206px',
          gap: '15px',
        },
      };
      break;

    case sliderType == 'visual-category' && aspectRatio == 'eight-nine':
      breakpoints = {
        0: {
          fixedWidth: '108px',
          height: 'calc(108px + (108px * 1/9))',
          gap: '6px',
          arrows: module.dataset?.showArrows == 'true' ? true : false,
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
        },
        500: {
          fixedWidth: '244px',
          height: 'calc(244px + (244px * 1/9))',
          gap: '24px',
        },
      };
      break;
    case sliderType == 'visual-category' && aspectRatio == 'two-one':
      breakpoints = {
        0: {
          fixedWidth: '244px',
          height: 'calc(244px * 1/2)',
          gap: '24px',
          arrows: module.dataset?.showArrows == 'true' ? true : false,
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
        },
      };
      break;
    case sliderLayout === 'fourUp' && cardCount > 4:
      breakpoints = {
        0: {
          fixedWidth: '241px',
          gap: '16px',
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
        },
        500: {
          fixedWidth: '254px',
          gap: '24px',
        },
        769: {
          fixedWidth: '329px',
          gap: '40px',
        },
        1025: {
          fixedWidth: '298px',
          gap: '40px',
        },
        1441: {
          fixedWidth: '298px',
          gap: '40px',
        },
      };
      break;
    case sliderLayout === 'fourUp' && cardCount === 4:
      breakpoints = {
        0: {
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
          fixedWidth: '241px',
          gap: '16px',
        },
        500: {
          fixedWidth: '254px',
          gap: '24px',
        },
        769: {
          fixedWidth: '329px',
          gap: '40px',
        },
        1025: {
          fixedWidth: '298px',
          gap: '40px',
        },
        1441: {
          fixedWidth: '298px',
          gap: '40px',
          destroy: true,
        },
      };
      break;
    case sliderLayout === 'fourUp' && cardCount === 3:
      breakpoints = {
        0: {
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
          fixedWidth: '241px',
          gap: '16px',
        },
        500: {
          fixedWidth: '254px',
          gap: '24px',
        },
        769: {
          fixedWidth: '329px',
          gap: '40px',
        },
        1025: {
          fixedWidth: '411px',
          gap: '40px',
          destroy: true,
        },
        1441: {
          fixedWidth: '411px',
          gap: '40px',
        },
      };
      break;
    case sliderLayout === 'fourUp' && cardCount === 2:
      breakpoints = {
        0: {
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
          fixedWidth: '241px',
          gap: '16px',
        },
        500: {
          fixedWidth: '348px',
          gap: '24px',
          destroy: true,
        },
        769: {
          fixedWidth: '451px',
          gap: '40px',
        },
        1025: {
          fixedWidth: '411px',
          gap: '40px',
        },
        1441: {
          fixedWidth: '411px',
          gap: '40px',
        },
      };
      break;
    case sliderLayout === 'fiveUp' && cardCount > 5:
      breakpoints = {
        0: {
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
          fixedWidth: '242px',
          gap: '12px',
        },
        500: {
          fixedWidth: '255px',
          gap: '24px',
        },
        769: {
          fixedWidth: '206px',
          gap: '40px',
        },
        1025: {
          fixedWidth: '244px',
          gap: '23px',
        },
        1441: {
          fixedWidth: '244px',
          gap: '23px',
        },
      };
      break;
    case sliderLayout === 'fiveUp' && cardCount === 5:
      breakpoints = {
        0: {
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
          fixedWidth: '242px',
          gap: '12px',
        },
        500: {
          fixedWidth: '255px',
          gap: '24px',
        },
        769: {
          fixedWidth: '206px',
          gap: '40px',
        },
        1025: {
          fixedWidth: '244px',
          gap: '23px',
        },
        1441: {
          fixedWidth: '244px',
          gap: '23px',
          destroy: true,
        },
      };
      break;
    case sliderLayout === 'fiveUp' && cardCount === 4:
      breakpoints = {
        0: {
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
          fixedWidth: '242px',
          gap: '12px',
        },
        500: {
          fixedWidth: '255px',
          gap: '24px',
        },
        769: {
          fixedWidth: '206px',
          gap: '40px',
        },
        1025: {
          fixedWidth: '244px',
          gap: '23px',
          destroy: true,
        },
        1441: {
          fixedWidth: '244px',
          gap: '23px',
        },
      };
      break;
    case sliderLayout === 'fiveUp' && cardCount === 3:
      breakpoints = {
        0: {
          arrowPath:
            'M17.3142 30.8529C16.6948 31.4822 15.679 31.4787 15.064 30.8452C14.4713 30.2347 14.4713 29.2637 15.064 28.6533L22.7885 20.6966C23.1652 20.3086 23.1652 19.6914 22.7885 19.3034L15.0641 11.3469C14.4714 10.7364 14.4714 9.76522 15.0641 9.15466C15.6791 8.52119 16.6948 8.51753 17.3144 9.14656L26.6182 18.5931C27.3848 19.3714 27.385 20.6208 26.6187 21.3994L17.3142 30.8529Z',
          fixedWidth: '242px',
          gap: '12px',
        },
        500: {
          fixedWidth: '255px',
          gap: '24px',
        },
        769: {
          fixedWidth: '206px',
          gap: '40px',
          destroy: true,
        },
        1025: {
          fixedWidth: '244px',
          gap: '23px',
          destroy: true,
        },
        1441: {
          fixedWidth: '244px',
          gap: '23px',
        },
      };
      break;
    case sliderLayout === 'oneUp':
      breakpoints = {
        0: {
          arrowPath:
            'M18.389 26.512c-.372.378-.982.375-1.35-.005-.356-.366-.356-.949 0-1.315l4.364-4.495c.376-.388.376-1.005 0-1.393l-4.364-4.496c-.356-.366-.356-.949 0-1.315.368-.38.978-.382 1.35-.005l5.03 5.107c.766.778.766 2.028 0 2.806l-5.03 5.11z',
          type: 'loop',
          pagination: true,
        },
        769: {
          pagination: false,
        },
      };
      break;
  }
  return breakpoints;
}
// Sets same height on all content slides in condensed compare sliders
export function setContentHeight(module) {
  if (
    module.dataset.sliderHeight &&
    module.dataset.sliderHeight.includes('equal')
  ) {
    const contentElems = Array.from([
      ...module.querySelectorAll('.content-equal-height'),
    ]);
    const contentHeight = contentElems.map((el) => el.offsetHeight);
    const maxHeight = Math.max(...contentHeight);
    contentElems.forEach((el) => (el.style.minHeight = `${maxHeight}px`));
  }
}
